import { TextField, Typography, Button, Link } from '@mui/joy';
import { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { signUpUser, validateEmail } from '../controllers/auth';
import Layout from '../Layout';
import VerifyOtp from './VerifyOtp';
import { useDispatchContext, useStateContext } from '../Store/Context';
import { setSnackbar } from '../controllers/snackController';
import { useSnackbarDispatch } from '../SnackbarDataStore/Context';
import NavBar from './WebPageComponents/NavBar';

/*
TODO: Validate signup form
*/

function SignUp() {

	const dispatch = useDispatchContext();
	const snackDispatch = useSnackbarDispatch();

	const [email, setEmail] = useState("");
	const [name, setName] = useState("");
	const [disabled, setDisabled] = useState(false);

	async function handleSignUp() {
		setDisabled(true);
		if (name==="") {
			setSnackbar(snackDispatch, "Enter your name", 'warning');
		} else if (email==="") {
			setSnackbar(snackDispatch, "Enter email", 'warning');
		} else if (!validateEmail(email)) {
			setSnackbar(snackDispatch, "Enter valid email", 'warning')
		} else {
			await signUpUser({name, email}, dispatch);
		}
		setDisabled(false);
	}

	const {otpSent, medium} = useStateContext();

	if (otpSent) {
		return (
			<VerifyOtp/>
		)
	}

	return (
		<>
			{medium==='web'&&<NavBar/>}
			<Layout>
				<div className='mb-4'>
					<Typography level='h4'>Create New Account</Typography>
				</div>
				<div className='mb-4'>
					<div className='mb-2'>
						<TextField
							onChange={(e) => setName(e.target.value)}
							name="name"
							variant='soft'
							placeholder="Rajnikant"
							label="Name"
							value={name}
						/>
					</div>
					<div className='mb-2'>
						<TextField
							onChange={(e) => setEmail(e.target.value)}
							name="email"
							variant='soft'
							placeholder="google@rajnikant.world"
							label="Email"
							value={email}
						/>
					</div>
					<Button disabled={disabled} sx={{ mt: 1 /* margin top */ }} onClick={handleSignUp}>Send OTP</Button>
				</div>
				<div className='mb-4'>
					<Typography>Already have an account, <Link component={RouterLink} to={"/signin"}>Sign In</Link> instead!!!</Typography>
				</div>
			</Layout>
		</>
	)
}

export default SignUp;